export const generateArrayOfNumbers = (from: number, to: number): number[] => {
  const array: number[] = [];

  if (from === to) return [from];

  const smaller = Math.min(from, to);
  const bigger = Math.max(from, to);
  const sign = from < to ? 1 : -1;
  const isAscending = sign === 1;

  if (isAscending) for (let i = smaller; i <= bigger; i += sign) array.push(i);
  else for (let i = bigger; i >= smaller; i += sign) array.push(i);

  return array;
};

export const monthsToYears = (months: number, decimalPlaces = 2): number => {
  return Number((months / 12).toFixed(decimalPlaces));
};
